export class AppStateFailureItem {
  public message: string;
  public constructor(message: string) {
    this.message = message;
  }
}
